import { lazy, Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import Error from "../Components/Error";
import { Provider } from "react-redux";
import store from "../Store/store";
import AuthContextProvider from "../Contexts/authContext";
import Register from "../Components/Auth/Register";
// import Profile from "../Components/Profile-1/Profile";
import Profile from "../Components/Profile/Profile";
import Login from "../Components/Auth/Login";
import Protection from "../Components/Auth/Protection";
import ForgotPassword from "../Components/Auth/ForgotPassword";
import ResetPassword from "../Components/Auth/ResetPassword";
import AuthChild from "../Components/Auth/AuthChild";

import FullJobDetails from "../Components/Jobs/FullJobDetails";
import JobSectionChild from "../Sections/JobSectionChild";

import InterviewContextProvider from "../Contexts/InterviewContext";
import AuthTokenSetUp from "../Components/AuthTokenSetUp";
import { Loader } from "../constents/components";
import { homePageAction } from "./routeActions";
import ShowProfileContextProvider from "../Contexts/showProfileContext";
// import PrivacyPolicy from "../Pages/PrivacyPolicy";
// import Teams from "../Pages/Teams";
import Pricing from "../Pages/Pricing";
import InterviewScreen from "../Components/Interview/InterviewScreen";
import Test from "../Components/Test/Test";
import RegistrationStepsWall from "../Components/Walls/RegistrationStepsWall";
import ProtectiedAfterAuth from "../Components/Auth/ProtectiedAfterAuth";
import MockContainer from "../Pages/MockContainer";
import Mock from "../Components/Mock/index";
import NewMock from "../Components/Mock/NewMock";
import MockInterview from "../Components/Mock/MockInterview";
import MockInterviewContextProvider from "../Contexts/mockInterviewContext";
import Purchase from "../Components/Payments/Purchase";
import SmallSignUpContextProvider from "../Contexts/smallSignUpContext";
import SmallSignupVerify from "../Components/Auth/RegistorComponents/SmallSignupVerify";
import Plans from "../Pages/Plans";
import MockReview from "../Pages/MockReview";
import MockRedeemPage from "../Components/Mock/MockRedeemPage";
// import CandidateServices from "../Pages/CandidateServices";
// import RecruiterServices from "../Pages/RecruiterServices";
// import NewPricing from "../Pages/NewPricing";

const Homepage = lazy(() => import("../Pages/Homepage"));
const InterviewPage = lazy(() => import("../Pages/InterviewPage"));
const Auth = lazy(() => import("../Components/Auth/Auth"));
const DashboardSection = lazy(() => import("../Sections/DashbordSection"));
const JobSectoin = lazy(() => import("../Sections/JobSectoin"));
const DiscoverSection = lazy(() => import("../Sections/DiscoverSection"));
const SettingSection = lazy(() => import("../Sections/SettingSection"));
const CvSection = lazy(() => import("../Sections/CvSection"));
const InterviewSection = lazy(() => import("../Sections/InterviewSection"));
const DiscForm = lazy(() => import("../Pages/DiscForm"));
const Terms = lazy(() => import("../Pages/Terms"));

export const sidebarDisabledRoutes = ["auth", "interview"];
export const NOT_TO_RECORD_AS_REDIRECT_URLS = [
  "/auth/login",
  "/auth/register",
  "/auth",
];

const routes = createBrowserRouter([
  {
    path: "/",
    element: (
      <ShowProfileContextProvider>
        <SmallSignUpContextProvider>
          <App />
        </SmallSignUpContextProvider>
      </ShowProfileContextProvider>
    ),
    errorElement: <Error />,
    loader: homePageAction,
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<Loader />}>
            <Protection>
              <DashboardSection />
            </Protection>
          </Suspense>
        ),
      },

      {
        path: "auth",
        element: (
          <Suspense fallback={<Loader />}>
            <Auth />
          </Suspense>
        ),
        children: [
          { index: true, element: <AuthChild /> },
          {
            path: "register",
            element: (
              <ProtectiedAfterAuth>
                <RegistrationStepsWall>
                  <Register />
                </RegistrationStepsWall>
              </ProtectiedAfterAuth>
            ),
          },
          {
            path: "login",
            element: (
              <ProtectiedAfterAuth>
                <Login />
              </ProtectiedAfterAuth>
            ),
          },
          { path: "forgotpassword", element: <ForgotPassword /> },
          { path: "reset-password", element: <ResetPassword /> },
        ],
      },

      {
        path: "dashboard",
        element: (
          <Suspense fallback={<Loader />}>
            <Protection>
              <DashboardSection />
            </Protection>
          </Suspense>
        ),
      },

      {
        path: "jobs",
        element: (
          <Suspense fallback={<Loader />}>
            <JobSectoin />
          </Suspense>
        ),
        children: [
          {
            index: true,
            element: (
              <Protection>
                <JobSectionChild />
              </Protection>
            ),
          },
          { path: ":id", element: <FullJobDetails /> }, // Dynamic route
        ],
      },

      {
        path: "discover",
        element: (
          <Suspense fallback={<Loader />}>
            <Protection>
              <DiscoverSection />
            </Protection>
          </Suspense>
        ),
      },

      // {
      //     path: "settings",
      //     element: <Suspense fallback={<Loader />}><Protection><SettingSection /></Protection></Suspense>,
      // },

      {
        path: "cv",
        element: (
          <Suspense fallback={<Loader />}>
            <CvSection />
          </Suspense>
        ),
      },

      {
        path: "interview",
        element: (
          <Suspense fallback={<Loader />}>
            <Protection>
              <InterviewContextProvider>
                <InterviewSection />
              </InterviewContextProvider>
            </Protection>
          </Suspense>
        ),
      },

      {
        path: "test/disc",
        element: (
          <Suspense fallback={<Loader />}>
            <Protection>
              <DiscForm />
            </Protection>
          </Suspense>
        ),
      },
      {
        path: "mock",
        element: (
          <Suspense fallback={<Loader />}>
            <Protection>
              <MockInterviewContextProvider>
                <MockContainer />
              </MockInterviewContextProvider>
            </Protection>
          </Suspense>
        ),
        children: [
          { index: true, element: <Mock /> },
          { path: "redeem", element: <MockRedeemPage /> },
          {
            path: "new-mock",
            element: (
              <MockInterviewContextProvider>
                <NewMock />
              </MockInterviewContextProvider>
            ),
          },
          {
            path: "mock-interview",
            element: <MockInterview />,
          },
          {
            path: "plans",
            element: <Plans />,
          },
          {
            path: "mock-review",
            element: <MockReview />,
          },
        ],
      },
      {
        path: "verify-account-small",
        element: <SmallSignupVerify />,
      },
      // {
      //     path: "terms-and-conditions",
      //     element: <Suspense fallback={<Loader />}><Terms /></Suspense>
      // },
      {
        path: "/purchase",
        element: (
          <Protection>
            {" "}
            <Purchase />
          </Protection>
        ),
      },
      // {
      //     path: "privacy-policy",
      //     element: <PrivacyPolicy />,
      // },
      // {
      //     path: "our-teams",
      //     element: <Teams />,
      // },
      // {
      //     path: "pricing",
      //     element: <NewPricing />,
      // },
      // {
      //     path: "services/candidates",
      //     element: <CandidateServices />,
      // },
      // {
      //     path: "services/recruiter",
      //     element: <RecruiterServices />,
      // },
      // {
      //     path: "plans",
      //     element: <Plans />,
      // },
      // {
      //     path: "test",
      //     element: <Test />
      // },
    ],
  },
]);

export default routes;
